import Control from '@/components/control';
import { useContext } from '@/components/slider-type/context';
import { useAppDispatch, useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { selectAnswersDefaultByKey, selectControlStateByKey, SliderSlice } from '@/redux/slider';
import '@/components/slider-type/components/textarea/textarea.css';

export default function Textarea() {
  const { slide } = useContext();
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const value = useAppSelector(selectAnswersDefaultByKey(slide.key));
  const state = useAppSelector(selectControlStateByKey(slide.key));
  const dispatch = useAppDispatch();

  const onChange = (key: string, value: string): void => {
    dispatch(SliderSlice.actions.setAnswersDefaultByKey({ key, value }));
  };

  return cssVersion === 1 ? (
    <div className='slider-type-text-area'>
      <textarea
        id={slide.key}
        value={value}
        className='slider-type-text-area__input'
        onChange={(e) => onChange(slide.key, e.target.value)}
        onBlur={() => dispatch(SliderSlice.actions.setValidationDirtyByKey(slide.key))}
      />
    </div>
  ) : (
    <Control.Textarea
      state={state}
      id={slide.key}
      value={value}
      onChange={(value, id) => onChange(id, value)}
      onBlur={(id) => dispatch(SliderSlice.actions.setValidationDirtyByKey(id))}
    />
  );
}
